<app-access-manager [namespace]="namespace">
@if (revenueEntered) {
  <div ngDefaultControl>
    <div
      class="cpo-section-container width-xl-half width-lg-half width-md-full width-sm-full"
      id="onboarding_businessInformationContainer"
    >
      <h2 class="cpo-section-title">Business Details</h2>
      <merchant-account-info
        #businessInfoForm
        [hideTitle]="true"
        [enableEditing]="false"
        [mode]="FormMode.Edit"
      ></merchant-account-info>
    </div>
    <div
      class="cpo-section-container paddedContent containerMargins"
      id="onboarding_processingInformationContainer"
    >
      <app-merchant-processors
        #processingForm
        [mode]="FormMode.Edit"
        [enableEditing]="false"
        [onboarding]="true"
      ></app-merchant-processors>
    </div>
    <div
      class="cpo-section-container paddedContent containerMargins"
      id="onboarding_processingInformationContainer"
    >
      <h2 class="cpo-section-title">Integrations</h2>
      @if (FormMode.Edit) {
      <app-selectbox
          [label]="'Partners'"
          [options]="integrationOptions"
          (onChanged)="onIntegrationChange($event)"
        ></app-selectbox>
      }
      @for (integration of intergations; track integration) {
        <div class="cpo-section-container" style="display: flex; flex-direction: column; gap: 10px;">
          @if (integration == 'Campfire') {
            <span style="font-family: 'Booton'; font-size: 20x; color: var(--green-800);">Campfire</span>
            <app-textbox
              [label]="'API Key'"
              [placeholder]="'Enter API Key'"
              [ngModel]="campfireApiKey"
              [readonly]="this.mode == FormMode.View"
              (onChanged)="onCampfireApiKeyChange($event)"
              >
            </app-textbox>
          }
          @if (integration == 'Friday Lunch') {
            <span style="font-family: 'Booton'; font-size: 13px; color: var(--gray-900);">No further information required</span>
          }
        </div>
      }
    </div>
    <div
      class="cpo-section-container paddedContent containerMargins"
      id="onboarding_userInformationContainer"
    >
      <h2 class="cpo-section-title">Primary Account User</h2>
      <div [hidden]="user == undefined">
        {{ user?.firstName }} {{ user?.lastName }} {{ user?.emailAddress }}
        <!-- TODO: select a different user-->
      </div>
      <div [hidden]="user != undefined">
        <!-- <p style="font-style: italic">
          You can add more users after you have set up the account.
        </p>
        <p>
          Enter the user's email address. If the user already exists, select the
          user to add to this business. Otherwise, you'll be prompted to add the
          rest of the user's information.
        </p> -->
        <app-user-form
          #userForm
          [showRequired]="true"
          [enableEditing]="false"
          [enableRoleSelection]="false"
          [enableSelectExistingUser]="true"
          [enableSaving]="false"
          [initialMode]="formMode.Edit"
          (saved)="handleNewUserSaved_callback($event)"
        ></app-user-form>
      </div>
      <!--
      <app-user-list #userForm [allowNew]="false" [enableEditing]="false" [mode]="'first'"></app-user-list>
      -->
    </div>
    <div style="text-align: right;">
      <input
        type="button"
        value="Create Account"
        class="btn-core"
        style="height: 50px; width: 150px;"
        (click)="btnSave_click()"
        (keydown.enter)="btnSave_click()"
      />
    </div>
  </div>
}
</app-access-manager>